var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SDialog',{attrs:{"value":_vm.value,"title":`Delete ${_vm.title}`,"btn-label":{ save: 'Delete' }},on:{"input":function($event){return _vm.$emit('input', $event)},"save":_vm.deleteEntity}},[_c('v-card',[_c('v-card-title',[_vm._v(" Are you sure you want to delete this "+_vm._s(_vm.title)+"? ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }